import * as CryptoJS from 'crypto-js';

const __$__ = process.env.REACT_APP_SK || '#D[^B!MJT%H~xRW';

/* Local Storage */
export const getData = (key) => {
    return DAR(key);
};
export const getDataUnsecure = (key) => {
    return localStorage.getItem(key);
};
export const saveData = (key, data) => {
    EAS(key, data);
};
export const saveDataUnsecure = (key, data) => {
    localStorage.setItem(key, data);
};
export const removeData = (key) => {
    localStorage.removeItem(key);
};
export const clearLocalStorage = () => {
    localStorage.clear();
};

/* Session Storage */
export const saveDataSession = (key, data) => {
    EASS(key, data);
};
export const getDataSession = (key) => {
    return DARS(key);
};
export const removeDataSession = (key) => {
    sessionStorage.removeItem(key);
};

/** Criptografia  */
const EAS = (key, data) => {
    let encData = ED(JSON.stringify(data), __$__);
    localStorage.setItem(key, encData);
};
const DAR = (key) => {
    const data = localStorage.getItem(key);
    if (data) {
        try {
            return JSON.parse(DD(data, __$__));
        } catch (e) {
            removeData(key);
            return null;
        }
    }
};
const EASS = (key, data) => {
    let encData = ED(JSON.stringify(data), __$__);
    sessionStorage.setItem(key, encData);
};
const DARS = (key) => {
    const data = sessionStorage.getItem(key);
    if (data) {
        try {
            return JSON.parse(DD(data, __$__));
        } catch (e) {
            removeData(key);
            return null;
        }
    }
};
const JsonFormatter = {
    stringify: (cipherParams) => {
        var jsonObj = { c: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
        if (cipherParams.iv) {
            jsonObj.a = cipherParams.iv.toString();
        }
        if (cipherParams.salt) {
            jsonObj.b = cipherParams.salt.toString();
        }
        return JSON.stringify(jsonObj);
    },
    parse: (jsonStr) => {
        var jsonObj = JSON.parse(jsonStr);
        var cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(jsonObj.c)
        });
        if (jsonObj.a) {
            cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj.a);
        }
        if (jsonObj.b) {
            cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj.b);
        }
        return cipherParams;
    }
};
const ED = (data, sk) => {
    return CryptoJS.AES.encrypt(data, sk, {
        format: JsonFormatter
    });
};
const DD = (eData, sk) => {
    return CryptoJS.AES.decrypt(eData, sk, {
        format: JsonFormatter
    }).toString(CryptoJS.enc.Utf8);
};
